/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class PendingSelections
 * @hideconstructor
 */
define([
	'underscore',
	'../../../../apiHelpers/SlotAPIHelper'
], (_, SlotAPIHelper) => {

	class PendingSelections {

		constructor(){
			this._pendingSelections = [];
		}

		select(selections) {
			_.each(selections, (selection) => {
				const isPending = _.find(this._pendingSelections, (p) => {
					return _.isEqual(p, selection);
				});
				if (!isPending) {
					this._pendingSelections.push(selection);
				}
			});
		}

		deselect(selections) {
			_.each(selections, (selection) => {
				const index = _.findIndex(this._pendingSelections, (p) => {
					return _.isEqual(p, selection);
				});

				if (index > -1) {
					this._pendingSelections.splice(index, 1);
				}
			});
		}

		clearAll() {
			this._pendingSelections.length = 0;
		}

		getSelections(selectedDataItemList = []) {
			const catDataItemList =_.filter(selectedDataItemList, (dataItem) => dataItem.getType() === 'attribute' && SlotAPIHelper.MULTI_MEASURES_SERIES !== dataItem.getColumnId());
			const selectDataItemIds = _.map(catDataItemList, (dataItem) => dataItem.getId());
			return _.filter(this._pendingSelections, (selection) => {
				return _.every(selectDataItemIds, (dataItemId) => {
					return _.find(selection.categories, (cat) => cat.dataItemId === dataItemId);
				});
			});
		}

		isSelected(selections) {
			return !!_.every(selections, (selection) => {
				return !!_.find(this._pendingSelections, (p) => {
					return _.isEqual(p, selection);
				});
			});
		}
	}

	return PendingSelections;
});
